import { BASE_URL } from "../common/constants";
import axios from "axios";
import { withTokenCheck } from "./userAxiosServices"
import { User } from "../common/user-model";

export interface StudentsSearchParams {
	currentPage: number;
	search: string;
}	

const getAllStudentsMySchool = async ({
  currentPage, 
	search
}: StudentsSearchParams) => {
  const response = axios.get(BASE_URL + `school/school-students/`, {
    params: { 
      page: currentPage,
			search: search,
    },
    headers: {
      Authorization: `JWT ${localStorage.getItem('access')}`,
      }
    });
  return response;
}

export const getAllStudentsMySchoolService = withTokenCheck(getAllStudentsMySchool)

const deleteStudent = async (studentId: string) => {
	const response = axios.delete(BASE_URL + `school/school-students/${studentId}/`, {
		headers: {
      Authorization: `JWT ${localStorage.getItem('access')}`,
      }
	})
	return response
}

export const deleteStudentService = withTokenCheck(deleteStudent)


const searchForStudents = async (search: string, schoolId: string) => {
	const response = axios.get(BASE_URL + `school/school-students/`, {
		params: {
			search: search,
			schoolId: schoolId
		},
		headers: {
			Authorization: `JWT ${localStorage.getItem('access')}`,
		}
	});
	return response;
}

export const searchUsersService = withTokenCheck(searchForStudents)

export const registerStudent = async ({
  firstName,
  lastName,
  email,
}: User) => {
  //const refCode = localStorage.getItem('ref_code')
  const response = axios.post(BASE_URL + 'school/register-student/', {
    first_name: firstName,
    last_name: lastName,
    email: email,
    //ref_code: refCode
  },
	{
		headers: {
			Authorization: `JWT ${localStorage.getItem('access')}`,
		}
	}
)
  return response
};

export const registerStudentService = withTokenCheck(registerStudent)


export const schoolRegisterUsers = async (file: File) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post(BASE_URL + 'school/bulk-create-users/', formData, {
      headers: {
        Authorization: `JWT ${localStorage.getItem('access')}`,
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  }
  catch (error: any) {
    console.error('Failed to register users:', error);
    throw error.response?.data || error.message;
  }
};

export const schoolRegisterUsersService = withTokenCheck(schoolRegisterUsers)

export const schoolListService = async (currentPage: number) => {
  try {
    const response = await axios.get(BASE_URL + 'school/schools-list/', {
      params: { 
        page: currentPage,
      },
    });

    return response;
  }
  catch (error: any) {
    throw error.response?.data || error.message;
  }
};

const getSchoolDetails = async () => {
  const response = axios.get(BASE_URL + `school/school-details/`, {
    headers: {
      Authorization: `JWT ${localStorage.getItem('access')}`,
    }
  });
  return response;
}

export const getSchoolDetailsService = withTokenCheck(getSchoolDetails)